import { useApiPaymentTransaction } from '@hooks-api/eCommerceV2/useApiPaymentTransaction'
import { Text } from '@pets-ui/Text/Text'
import { type MobileMediaQuery } from '@pets-ui/tokens/breakpoints.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import * as stylex from '@stylexjs/stylex'
import { useParams } from 'react-router-dom-v5'
import { useCheckout } from '../../../../fp-b2b-shared/hooks/use-checkout'
import { PaymentDetailsUI } from '../PaymentDetailsUI'

const MOBILE: MobileMediaQuery = '@media (max-width: 480px)'

const styles = stylex.create({
  isMobile: {
    marginTop: {
      [MOBILE]: 20,
      default: 0,
    },
  },
})

export function RetryPaymentDetailsUI() {
  const { countryCode } = useCheckout()
  const { transactionId } = useParams<{ transactionId?: string }>()
  const { destructuredData: transaction } = useApiPaymentTransaction(countryCode
    ? {
      country_code: countryCode,
      payment_transaction_id: transactionId ?? '',
    }
    : undefined)
  return (
    <VStack gap={2} rootStyle={styles.isMobile}>
      <Text variant="h5">付款明細</Text>
      <PaymentDetailsUI
        discountItems={transaction?.discount_items || []}
        shippingTotal={transaction?.shipping_total ?? 0}
        total={transaction?.total ?? 0}
        subtotal={transaction?.subtotal ?? 0}
        tax={transaction?.tax ?? 0}
        currency={transaction?.currency || '(幣別未知)'}
        countryCode={countryCode}
        addonV2Total={transaction?.addon_v2_total ?? 0}
        addonV2TotalBeforeDiscount={transaction?.addon_v2_total_before_discount ?? 0}
      />
    </VStack>
  )
}
